module.exports = __webpack_public_path__ + "static/media/20.b2d1c480.jpg";